import React from 'react';

const AdminMainPage = () => {
    return (
            <div className=''>
                <h1>Panel Principal</h1>
            </div>
    );
};

export default AdminMainPage;
